import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-template-config-skeleton',
  templateUrl: './template-config-skeleton.component.html',
  styleUrls: ['./template-config-skeleton.component.scss']
})
export class TemplateConfigSkeletonComponent {
  // Propriété pour contrôler l'affichage des différentes sections
  @Input() showLeftPanel: boolean = true;
  @Input() showRightPanel: boolean = true;
  @Input() showPreview: boolean = true;
}